import { render } from "./alunoAll.vue?vue&type=template&id=bfd4ccca&scoped=true"
import script from "./alunoAll.vue?vue&type=script&lang=js"
export * from "./alunoAll.vue?vue&type=script&lang=js"

import "./alunoAll.vue?vue&type=style&index=0&id=bfd4ccca&lang=scss&scoped=true"
import "./alunoAll.vue?vue&type=style&index=1&id=bfd4ccca&lang=css"
import "./alunoAll.vue?vue&type=style&index=2&id=bfd4ccca&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd4ccca"]])

export default __exports__